<template>
  <div class="g-wrapper g-vertical-block">
    <div class="c-document g-main-wrapper">
      <ptomAgentInfo-filter placeholder="代理商ID/代理商名称" @on-set="editAgentInfo" @on-search="getData" />
      <Viewport v-model="height">
        <div class="c-table-list">
          <ptomAgentInfo-table
            :loading="loading"
            :height="height - 40"
            :data="tableList"
            :columns="tableCol"
            @on-refresh="getData"
            @on-edit="editAgentInfo"
          />
          <el-pagination
            :total="total"
            :current-page.sync="pageIndex"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="changePageIndex"
            @size-change="changePageSize"
            class="c-table-page"
            background
          />
        </div>
      </Viewport>

      <!-- 弹出框 -->
      <ptomAgentInfo-set
        ref="ptomAgentInfoSetRef"
        v-model="isModel"
        title="代理商配置"
        :edit="edit"
        :loading="loading"
        @on-save="saveAgentInfo"
      />
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/ptom_agent_info_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, trim } from '@/common/js/utils'
import { getAgentInfo, addAgentInfo, updateAgentInfo } from '@/api/ptomAgentInfo.model'
import ptomAgentInfoFilter from './components/ptomAgentInfo-filter.vue'
import ptomAgentInfoTable from './components/ptomAgentInfo-table.vue'
import ptomAgentInfoSet from './components/ptomAgentInfo-set.vue'
export default {
  name: 'ptomAgentInfo',
  mixins: [mixin],
  components: { ptomAgentInfoFilter, ptomAgentInfoTable, ptomAgentInfoSet },
  methods: {
    getData(filter) {
      if (filter) this.pageIndex = 1
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else if (this.params) params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      getAgentInfo(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              return ret
            })
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    editAgentInfo(edit) {
      this.edit = !!edit
      console.log(edit)
      if (edit) {
        const params = {
          id: edit.id,
          pageIndex: 0,
          pageSize: this.pageSize
        }
        this.loading = true
        getAgentInfo(params)
          .then((data) => {
            this.loading = false

            if (data && isArray(data.list) && data.list.length === 1) {
              const { id, agentName, field3, field1, field2, field4 } = data.list[0]
              this.info = { state: 2, id, agentName, field3, field1, field2, field4 }
              this.isModel = true
              this.$nextTick(() => {
                this.$refs.ptomAgentInfoSetRef.setForm(this.info)
              })
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
      } else {
        this.info = { state: 1, id: '', agentName: '', field1: '', field2: '', field4: '' }
        this.isModel = true
        this.$nextTick(() => {
          this.$refs.ptomAgentInfoSetRef.setForm(this.info)
        })
      }
    },
    saveAgentInfo(params) {
      let { state, id, agentName, field3, field1, field2, field4 } = params
      console.log(state)

      agentName = trim(agentName)
      field3 = trim(field3)
      field1 = trim(field1)
      field2 = trim(field2)
      field4 = trim(field4)
      if (state === 2) {
        this.loading = true
        updateAgentInfo({ id, agentName, field3, field1, field2, field4 })
          .then((data) => {
            this.loading = false
            if (data) {
              this.$message.success('更新成功！')
              this.getData()
              this.isModel = false
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
      } else if (state === 1) {
        this.loading = true
        addAgentInfo({ agentName, field3, field1, field2, field4 })
          .then((data) => {
            this.loading = false
            if (data) {
              this.$message.success('添加成功！')
              this.getData()
              this.isModel = false
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
      } else {
        this.$message.error('操作失败！')
      }
    },
    setLocalPage(size) {
      setLocal('DOCUMENT_PAGESIZE', size)
    },
    proloadData() {}
  },
  data() {
    return {
      isModel: false, // 弹窗开关
      saving: false, // 设置状态
      edit: null,
      info: {},
      height: 330
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('DOCUMENT_PAGESIZE')) || 20
    this.tableCol = columns
    this.getData()
    // this.proloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-document {
  width: 100%;
  height: 100%;
  padding: 8px 8px 0;
}

.c-table-list {
  height: calc(100% - 48px);
}

.c-table-page {
  padding: 0 8px;
  margin-top: 6px;
  text-align: right;
}
</style>
